import { createRoot } from 'react-dom/client';
import { configureCoreEnv } from '@antecipa/core';
import { OverrideConsole } from '@antecipa/core/helpers/logger/override-console';

import { Startup } from './application/startup/startup.component';

// StyleSheets
import './presentation/assets/styles/index.css';

configureCoreEnv({
  VITE_APPLICATION_ENV: import.meta.env.VITE_APPLICATION_ENV,
  VITE_APPLICATION_CODE: import.meta.env.VITE_APPLICATION_CODE,
  VITE_APPLICATION_NAME: import.meta.env.VITE_APPLICATION_NAME,
  VITE_API_DOMAIN: import.meta.env.VITE_API_DOMAIN,
  VITE_AUTH_URL: import.meta.env.VITE_AUTH_URL,
  VITE_AUTH_NEGOCIA_URL: import.meta.env.VITE_AUTH_NEGOCIA_URL,
  VITE_AUTH_NEGOCIA_CERC_URL: import.meta.env.VITE_AUTH_NEGOCIA_CERC_URL,
  VITE_BUILD_VERSION: import.meta.env.VITE_BUILD_VERSION,
  VITE_COOKIE_DOMAIN: import.meta.env.VITE_COOKIE_DOMAIN,
  VITE_SIDEBAR_TYPE: import.meta.env.VITE_SIDEBAR_TYPE,
  VITE_VERSION: import.meta.env.VITE_VERSION,
});

if (import.meta.env.VITE_FORWARD_CONSOLE_TO_DATADOG === 'true') {
  OverrideConsole();
}

const container = document.getElementById('root');
if (container) {
  createRoot(container).render(<Startup />);
}
